var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1569 799L1569 827",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1569.5,
    cy: 794.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.99 794.19C1564.99 790.283 1568.29 787.117 1572.36 787.117C1572.94 787.117 1573.51 787.184 1574.06 787.308C1572.74 786.48 1571.19 786 1569.52 786C1564.81 786 1561 789.806 1561 794.5C1561 799.194 1564.81 803 1569.52 803C1571.81 803 1573.89 802.093 1575.43 800.62C1574.49 801.032 1573.45 801.263 1572.36 801.263C1568.29 801.263 1564.99 798.096 1564.99 794.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1578.4 793.6L1578.37 791.146L1576.54 792.719L1574.3 792.056L1575.11 794.337L1573.77 796.381L1576.1 796.218L1577.5 798.144L1578.13 795.763L1580.34 794.909L1578.4 793.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.66453d8074ba46c6731b03758e5a816c.svg";
export { ForwardRef as ReactComponent };